import moment from 'moment'
import {calculateDate} from '../../../../utils'
import {ListInputFieldForm} from '../../../../utils/TypeCommon'
import {ContractModel} from '../../healthInsurance/model/ContractModel'
import {InsurancePlanModel} from '../../healthInsurance/model/InsurancePlanModel'

interface MotoListInsuredModel {
  id: string | null
  ownerCode: string | null
  ownerVersion: string | null
  oldContractCode: string | null
  certType: string | null
  certNumber: string | null
  vehicleOwner: string | null
  address: string | null
  licensePlate: string | null
  chassisNumber: string | null
  engineNumber: string | null
  timeDuration: string | null
  startDate: string | null
  expireDate: string | null
  objectInsuredType: string | null
  manufacturingYear: string | null
  seat: string | null
  bikeCompany: string | null
  bikeBrand: string | null
  vehicleGroupsCode: string | null
  packageCode: string | null
  sumFee: string | null
  sumTax: string | null
  validateForm: boolean | null
  listMoto: any
  payeeName: string | null
  payeeNameIdentificationNumber: string | null
  payeesRelationsShip: string | null
  payeePhone: string | null
  payeeEmail: string | null
  packageChoosed: string | null
  listObjectSelected: any
  vehiclePackageBenefitDtos: any
  contractPackageBenefitChecked: any
  fieldInput: ListInputFieldForm
  nationality: string | null
}

export interface MotoInitialStateModel {
  tabName?: string
  sellingContractId?: string
  customerCode?: string
  customerVersion?: number
  groupDomainCode?: string
  contractType?: number
  contractKind?: number
  originalContract?: string
  packageExtension?: any
  packageInsurance?: any
  form: {
    activeForm: number
    formStatus: number | null
    formData: {
      formMotoInsurancePlan?: InsurancePlanModel
      formMotoListInsured?: MotoListInsuredModel
      formMotoContract?: ContractModel
    }
  }
}

export interface ListMotoInitialStateModel extends Array<MotoInitialStateModel> {}

export const motoInitialState: ListMotoInitialStateModel = [
  {
    tabName: undefined,
    sellingContractId: undefined,
    customerCode: undefined,
    customerVersion: undefined,
    groupDomainCode: undefined,
    contractType: undefined,
    contractKind: undefined,
    originalContract: undefined,
    packageExtension: undefined,
    packageInsurance: undefined,
    form: {
      activeForm: 1,
      formStatus: null,
      formData: {
        formMotoInsurancePlan: {
          businessProgramCode: null,
          productCode: 'MOTOBIKE',
          exploitingType: null,
          exploitingCode: null,
          typeOfIntroduction: null,
          introductionCode: null,
          curencyMoney: null,
          curencyFee: null,
          exchangeRate: '1',
          exchangeRateNote: null,
          business: null,
          businessName: null,
          currencyFeeChange: null,
          validateForm: null,
          tpa: null,
          tpaType: null,
          tpaFee: null,
          adjacentContractNumberLoss: null,
          adjacentContractNumber: null,
          paymentTimeType: null,
          paymentTimeDay: null,
          calculationType: '0',
          nationality: null,
        },
        formMotoListInsured: {
          id: null,
          certType: null,
          certNumber: null,
          ownerCode: null,
          ownerVersion: null,
          oldContractCode: null,
          vehicleOwner: null,
          address: null,
          licensePlate: null,
          chassisNumber: null,
          engineNumber: null,
          timeDuration: null,
          startDate: moment().format('YYYY/MM/DD HH:mm'),
          expireDate: calculateDate(moment().format('YYYY/MM/DD HH:mm'), true),
          objectInsuredType: null,
          manufacturingYear: null,
          seat: null,
          bikeCompany: null,
          bikeBrand: null,
          vehicleGroupsCode: null,
          packageCode: null,
          sumFee: null,
          sumTax: null,
          validateForm: null,
          listMoto: null,
          payeeName: null,
          payeeNameIdentificationNumber: null,
          payeesRelationsShip: null,
          payeePhone: null,
          payeeEmail: null,
          fieldInput: [],
          packageChoosed: null,
          listObjectSelected: null,
          vehiclePackageBenefitDtos: null,
          contractPackageBenefitChecked: null,
          nationality: null,
        },
        formMotoContract: {
          agency: null,
          contractType: null,
          contractNumber: null,
          originalCode: null,
          created: null,
          purchaseDate: null,
          startDate: null,
          expireDate: null,
          manager: null,
          totalPerson: null,
          sumFee: null,
          partyARepresentative: null,
          partyAPosition: null,
          partyBRepresentative: null,
          partyBPosition: null,
          partyBPhone: null,
          partyAPhone: null,
          partyAPowerOfAttorney: null,
          partyBPowerOfAttorney: null,
          partyBFax: null,
          proxy: null,
          bankCode: null,
          sumTax: null,
          taxType: '1',
          bankNumber: null,
          _sellingContractPaymentScheduleDtos: null,
          _sellingContractExtraDataDtos: null,
          _listContractPackages: null,
          lossRatio: null,
          validateForm: null,
          exploName: null,
          exploManager: null,
          exploitingType: null,
          tsIncharge: null,
          pmIncharge: null,
          paymentTimeType: null,
          commission: '0',
          adminFee: '0',
          vatAdminFee: null,
          endorStartDate: null,
          endorExpireDate: null,
          endorNote: null,
          userReceiveMail: null,
          customerConfirmDate: null,
          dateMoF: null,
        },
      },
    },
  },
]
